import React from 'react'
import Logo from "../../../../Reutilizables/Logo"
import MenuTasas from './MenuTasas'
import TituloImpuestosMunicipales from '../../../../Reutilizables/TituloImpuestosMunicipales'
import Redes from "../../../../Reutilizables/Redes"

function Derecho_trancito() {
  return (
    <>
      <div className='container-logo-menu'>
        <Logo />
        <MenuTasas />
      </div>
      <TituloImpuestosMunicipales />
      <Redes />
    </>
  )
}

export default Derecho_trancito